import { useEffect, useMemo, useState } from "react";

const RATE = 0.28;

export const useStats = () => {
  const [duration, setDuration] = useState(1); // Duration in seconds
  const [power, setPower] = useState('0.05'); // Power in kWh

  useEffect(() => {
    const interval = setInterval(() => {
      setDuration((prev) => prev + 1); // Increase duration by 1 second
      setPower((prev) => (parseFloat(prev) + parseFloat(getRandomPowerIncrement(0.05, 0.1))).toFixed(2)); // Increase power by a random amount between 0.3 and 0.8 kWh
    }, 1000); // Update every second

    // Clear the interval when the component unmounts
    return () => clearInterval(interval);
  }, []);

  const cost = useMemo(() => (parseFloat(power) * RATE).toFixed(2), [power]);

  return {
    power,
    duration,
    cost
  }
}

const getRandomPowerIncrement = (min, max) => {
  return (Math.random() * (max - min) + min).toFixed(2);
};